import { Tag } from 'antd';
import type React from 'react';

type SecondRowState = {
  drivers: { driverName: string; driverId: string }[];
};

export const DriverWithDistrictsView: React.FC<{
  store: {
    secondTableRowStates: Record<string, SecondRowState>;
    deleteDistrictDriver: (districtId: string, driverId: string) => void | Promise<void>;
  };
  districtId: string;
}> = ({ store, districtId }) => {
  return (
    <div>
      {store.secondTableRowStates[districtId].drivers.map((driver) => {
        return (
          <Tag
            key={driver.driverId}
            color={'blue'}
            onClose={() => store.deleteDistrictDriver(districtId, driver.driverId)}
            closable
            style={{ fontSize: 14, margin: 0 }}
          >
            {driver.driverName}
          </Tag>
        );
      })}
    </div>
  );
};
